import searchFormChange from '../actions/searchFormChange'
import searchPOIByAddress from '../actions/searchPOIByAddress'
import R from 'ramda'

import getCurrentQuery from '../utils/getCurrentQuery'

export default (address, coordinates) => (dispatch, getState) => {
  const query = getCurrentQuery()
  const nextIndex = R.filter((p) => R.not(p.type), query.pois).length + 1;
  const newPoi = {
    description: address,
    coordinates: coordinates,
    isOpen: true,
    markerCount: nextIndex,
    type:"",
  }
  
  const insertPOI = (newPOI, poiArray) => {
     const lastPoiIndex = R.findLastIndex(R.propEq("type", ""), query.pois);
     return R.insert(lastPoiIndex + 1, newPoi, query.pois)
  }
  
  dispatch(searchFormChange(['pois'], insertPOI(newPoi, query.pois)))
  dispatch(searchPOIByAddress(""))
}



/** WEBPACK FOOTER **
 ** ./app/actions/addPoiFromSearch.js
 **/